import axios from '../../utils/axiosinstance'
// import axios from 'axios'
const state = {
   project: {shortname: '',cr_params: {}},
   currentUser: null,
   cityWeather: {},
   fieldsGroups: [],
   paramsGroup: [],
   projectUsers: [],
   customerUsers: [],
   projectServices: [],
   logoOne: '',
   logoTwo: '',
   projectImage: '',
   is_loading: true,
   weatherReports: [],
   userTemplates: [],
  constructionTemplates: []
}
const mutations = {
    settingsModuleSetLoading: (state , value) =>{
   state.is_loading = value;
  },
  setUserTemplates: (state, val ) => {
    state.userTemplates = val
  },
  setConstructionTemplates: (state, val ) => {
    state.constructionTemplates = val
  },
  setCurrentUser: (state, val) => {
    state.currentUser = val
  },

  setProjectDetails: (state,payload) => {
    state.project = payload;
    state.project.params = payload.params.sort((a,b) => a.order - b.order)
    const val = JSON.parse(JSON.stringify(state.project.params))
    let grouped = val.reduce((entryMap, e ) => entryMap.set(e.group, [...entryMap.get(e.group) || [], e]), new Map())
    state.paramsGroup = Array.from(grouped, ([groupName, items]) => {
      let words = items.sort((a, b) => a.order - b.order)
      return {groupName: groupName , items: words}
    });
  },
  setProjectParams: (state,payload) => {
    state.project.params = payload
    console.log('Import 2', payload)
    console.log('Import 3', state.paramsGroup)
  },

  setCityWeather: (state, payload) => {
    // when user will select from dropdown then call this mutation
    state.project.weathercity = payload.name
    state.project.weathercitycode = payload.city_code
    state.project.weathercountry = payload.country
    state.project.weatherzipcode = payload.plz
  },

  setWeathers: (state, payload) => {
    state.weatherReports = payload
  },

  setFieldsGroups: (state, payload) => {
    state.fieldsGroups = payload
  },

  setProjectUsers: (state, payload) => {
    state.projectUsers = payload
  },
  setProjectServices: (state, payload) => {
    state.projectServices = payload
  },

  setCustomerUsers: (state, payload) => {
    state.customerUsers = payload
  },

  setDecoLogoOneImage: (state, payload) => {
    state.logoOne = payload
  },
  setDecoLogoTwoImage: (state, payload) => {
    state.logoTwo = payload
  },
  setDecoProjectImage: (state, payload) => {
    state.projectImage = payload
  },

  setLogoOrProjectPhotos: (state, payload) => {
    if (payload.type === 'logoOne') {
      state.project.logo1 = payload.photo_id
    } else if (payload.type === 'logoTwo') {
      state.project.logo2 = payload.photo_id
    } else {
      state.project.decoimage = payload.photo_id
    }
  }
}
const actions = {

  async deleteTemplate ({commit}, id) {
    // eslint-disable-next-line camelcase
    let isSuccess = false
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        'methodName': 'deleteProjectTemplate',
        'parameters': [id],
        'serviceName': 'ProjectdocuService'
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      console.log(res, 'here is response')
      // eslint-disable-next-line camelcase
      isSuccess = true
    }).catch(error => {
      console.error('Error deleting template:', error) // Fehler behandelt
    })
    // eslint-disable-next-line camelcase
    return isSuccess
  },

  async logout({commit}){
    commit('settingsModuleSetLoading',true);
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "logout",
        "parameters": null,
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      console.log(res.data,"logout successfully");
    }).catch(error => {
      commit('settingsModuleSetLoading',false);
    })
  },

  /**Get Settings Templates By User
   *
   * @param commit
   * @param id
   * @returns {Promise<void>}
   */
  async getSettingsTemplatesByUser({commit}, id){
    await commit('settingsModuleSetLoading',true);
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getProjectTemplatesByCustomer",
        "parameters": [id],
        "serviceName": "ProjectdocuService"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      commit("setUserTemplates",res.data)
      commit('settingsModuleSetLoading',false);
    }).catch(error => {
      commit('settingsModuleSetLoading',false);
    });
  },


  async saveSettingsTemplate({commit,dispatch,state},payload){
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "updateProjectTemplate",
        "parameters": payload,
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
          this._vm.$toast.success('Vorlage gespeichert');
         dispatch('getSettingsTemplatesByUser',state.project.customer_id)
         commit('settingsModuleSetLoading',true);
    }).catch(error => {
      this._vm.$toast.error('oops. ! Something went wrong');
    })
  },


  /**Get Construction Settings Templates
   *
   * @param commit
   * @param id
   */
   getSettingsConstructionTemplate({commit}, id){
    commit('settingsModuleSetLoading',true);
      axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getCRTemplatesByCustomer",
        "parameters": [id],
        "serviceName": "ProjectdocuService"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      commit("setConstructionTemplates",res.data)
      commit('settingsModuleSetLoading',false);
    }).catch(error => {
      commit('settingsModuleSetLoading',false);
    })
  },


  /**Save Construction Settings Template
   *
   * @param commit
   * @param payload
   * @returns {Promise<void>}
   */
  async saveConstructionSettingsTemplate({commit},payload){
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "updateCRTemplate",
        "parameters": payload,
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      this._vm.$toast.success('Vorlage gespeichert');
      commit('settingsModuleSetLoading',true);
    }).catch(error => {
      this._vm.$toast.error('oops. ! Something went wrong');
    })
  },


   getProjectDetails({commit,dispatch},id){
    commit('settingsModuleSetLoading',true);
       axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getProject",
        "parameters": [id.toString()],
        "serviceName": "ProjectdocuService"
       },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.statusText === "OK" || res.status === 200){
          commit('settingsModuleSetLoading',false);
          commit("setProjectDetails",res.data[0]);
          dispatch('getSettingsTemplatesByUser',res.data[0].customer_id);
          dispatch('getSettingsConstructionTemplate',res.data[0].customer_id);
          dispatch('getDocuLogoImage',{project_id: id,logo_id: res.data[0].logo1 ,img: "logoOne"});
          dispatch('getDocuLogoImage',{project_id: id,logo_id: res.data[0].logo2 ,img: "logoTwo"});
          dispatch('getDocuLogoImage',{project_id: id,logo_id: res.data[0].decoimage ,img: "projectImage"});
          dispatch('getCustomerUsers',res.data[0].customer_id);
      }
    }).catch(error => {
       commit('settingsModuleSetLoading',false);
     })
  },


  async updateProjectDetails({commit,state , dispatch}){
    commit('settingsModuleSetLoading',true);
    await dispatch('updateFieldsGroupData', state.fieldsGroups)
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "updateProject",
        "parameters": [state.project.projectid.toString(),state.project],
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.statusText === "OK" || res.status === 200){
        commit('settingsModuleSetLoading',false);
        this._vm.$toast.success('Einstellungen gespeichert')
      }
    }).catch(error => {
      commit('settingsModuleSetLoading',false);
      this._vm.$toast.error('Oops Something went wrong... !')
    });
  },


  async getCityWeather({commit},city_names){
    commit('settingsModuleSetLoading',true);
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getWeatherCityCode",
        "parameters": [city_names],
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.statusText === "OK" || res.status === 200){
        commit('settingsModuleSetLoading',false);
          commit('setCityWeather',res.data.search.result[0]);
          commit('setWeathers',res.data.search);
      }
    }).catch(error => {
      commit('settingsModuleSetLoading',false);
    })
  },

   getFieldsGroupData({commit},id){
    commit('settingsModuleSetLoading',true);
     axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
        "methodName": "getGroupsForProject",
        "parameters": [id.toString()],
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.statusText === "OK" || res.status === 200){
        let groups = res.data.map(item => {
          item.deleted = 0;
          return item
        });
        commit('setFieldsGroups', groups);
        commit('settingsModuleSetLoading',false);
      }
    }).catch(error => {
      commit('settingsModuleSetLoading',false);
      console.log(error);
    })
  },


   getProjectUsers({commit},id){
    commit('settingsModuleSetLoading',true);
     axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
        "methodName": "getUsersOfProject",
        "parameters": [id.toString()],
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.statusText === "OK" || res.status === 200){
         commit('settingsModuleSetLoading',false);
         commit('setProjectUsers',res.data)
      }
    }).catch(error => {
      commit('settingsModuleSetLoading',false);
      console.log(error);
    })
  },


   getCustomerUsers({commit},id){
    commit('settingsModuleSetLoading',true);
     axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
        "methodName": "getUsersOfCustomer",
        "parameters": [id.toString()],
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.statusText === "OK" || res.status === 200){
        commit('settingsModuleSetLoading',false);
        commit('setCustomerUsers',res.data)
      }
    }).catch(error => {
      commit('settingsModuleSetLoading',false);
      console.log(error);
    })
  },

 //get project services for trades tab
   getProjectServices({commit},id){
    commit('settingsModuleSetLoading',true);
     axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
        "methodName": "getProjectServices",
        "parameters": [id.toString()],
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.statusText === "OK" || res.status === 200){
        commit('setProjectServices',res.data)
        // console.log(res.data,"hello world....")
        commit('settingsModuleSetLoading',false);
      }
    }).catch(error => {
      console.log(error);
    })
  },

//update project services for trades tab
  async updateProjectServices({commit},payload){
    commit('settingsModuleSetLoading',true);
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
        "methodName": "setProjectService",
        // set third param false for delete
        "parameters": [payload.id.toString(), payload.service.pdserviceid, payload.service.checked === 'true'],
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.statusText === "OK" || res.status === 200){
       console.log("here is status from trade........");
        this._vm.$toast.success('Gewerk aktiviert')
        commit('settingsModuleSetLoading',false);
      }
    }).catch(error => {
      console.log(error);
    })
  },

   getDocuLogoImage({commit},params){
    commit('settingsModuleSetLoading',true);
    let url = `${process.env.VUE_APP_GET_METHOD_URL}deco&projectid=${params.project_id}&id=${params.logo_id}&tt=xx&token=${localStorage.sessiontoken}`;
     fetch(url,
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => response.blob())
      .then(response => {
        let reader = new FileReader()
        reader.readAsDataURL(response)
        reader.onload = function () {
         if(params.img === "logoOne"){
           commit("setDecoLogoOneImage",reader.result)
         }else if(params.img === "logoTwo"){
           commit("setDecoLogoTwoImage",reader.result)
         }else if (params.img === "projectImage"){
           commit("setDecoProjectImage",reader.result)
         }
          commit('settingsModuleSetLoading',false);
        }
      }).catch(error => {
        commit('settingsModuleSetLoading',false);
      console.log(error);
    })
  },

  async updateFieldsGroupData({commit},data){
    commit('settingsModuleSetLoading',true);
    data.forEach(function (item, idx) {
      if (item.deleted === undefined) item.deleted = 0
      item.projectid = state.project.projectid.toString()
    })
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "updateCRGroups",
        "parameters": [data],
        "serviceName": "ProjectdocuService"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.statusText === "OK" || res.status === 200){
          commit("settingsModuleSetLoading",false)
      }
    }).catch(error => {
      console.log(error);
      commit("settingsModuleSetLoading",false)
    })
  },


}
const getters = {

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/appSettings.js